import { Box, IconButton } from '@mui/material'
import React from 'react'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'

type ReportElementSortButtonProps = {
  onSort: (value: null | string | number, direction: 'asc' | 'desc') => void
  sortValue: string | number
  currentSort: { value: string; direction: 'asc' | 'desc' }
}

const ReportElementSortButton: React.FC<ReportElementSortButtonProps> = ({
  onSort,
  sortValue,
  currentSort,
}) => {
  const { value, direction } = currentSort

  const handleSort = () => {
    if (value === sortValue) {
      direction === 'asc' ? onSort(sortValue, 'desc') : onSort(null, 'asc')
    } else {
      onSort(sortValue, 'asc')
    }
  }
  return (
    <IconButton size="small" onClick={handleSort} sx={{ fontSize: '14px' }}>
      <ArrowDownwardIcon
        fontSize="inherit"
        color={
          sortValue === currentSort.value && direction === 'asc'
            ? 'secondary'
            : 'inherit'
        }
      />
      <ArrowUpwardIcon
        fontSize="inherit"
        color={
          sortValue === currentSort.value && direction === 'desc'
            ? 'secondary'
            : 'inherit'
        }
      />
    </IconButton>
  )
}

export default ReportElementSortButton
